import { render } from "./SessionExpiryWarning.vue?vue&type=template&id=19efca5a&scoped=true"
import script from "./SessionExpiryWarning.vue?vue&type=script&lang=js"
export * from "./SessionExpiryWarning.vue?vue&type=script&lang=js"

import "./SessionExpiryWarning.vue?vue&type=style&index=0&id=19efca5a&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19efca5a"]])

export default __exports__